import React, { useState } from 'react';
import styled from 'styled-components';
import GracielaGif from '../images/graciela-tits.gif';

const AgeVerification = ({ onVerified }) => {
  const [birthday, setBirthday] = useState('');
  const [error, setError] = useState('');

  const handleVerify = () => {
    const age = getAge(new Date(birthday));
    // Secretly allow 18+, but display as if it's 21+
    if (age >= 18) {
      onVerified();
    } else {
      setError('You must be over 21 to enter this site.');
    }
  };

  const getAge = birthDate => {
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      return age - 1;
    }
    return age;
  };

  return (
    <Wrapper>
      <GifContainer>
        <Gif src={GracielaGif} alt="Mature Content GIF" />
      </GifContainer>
      <Notice>
        Mature Content Notice: You must be over 21 to enter this site.
      </Notice>
      <Input
        type="date"
        value={birthday}
        onChange={e => setBirthday(e.target.value)}
        placeholder="Enter your birthday"
      />
      <Button onClick={handleVerify}>Verify Age</Button>
      {error && <Error>{error}</Error>}
    </Wrapper>
  );
};

export default AgeVerification;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background-color: black;
  color: white;
  padding: 20px;
  box-sizing: border-box;

  /* Alienware Aurora 16X optimization (2560x1600) */
  @media (min-width: 2560px) {
    padding: 60px;
    min-height: 100vh;
  }

  @media (min-width: 1920px) and (max-width: 2559px) {
    padding: 40px;
  }

  /* iPhone 15+ and Samsung Galaxy optimization */
  @media (max-width: 430px) {
    padding: 15px;
  }

  @media (max-width: 390px) {
    padding: 12px;
  }

  @media (max-width: 360px) {
    padding: 10px;
  }
`;

const GifContainer = styled.div`
  margin-bottom: 20px;

  /* Alienware Aurora 16X optimization (2560x1600) */
  @media (min-width: 2560px) {
    margin-bottom: 50px;
  }

  @media (min-width: 1920px) and (max-width: 2559px) {
    margin-bottom: 35px;
  }
`;

const Gif = styled.img`
  max-width: 100%;
  height: auto;

  /* Alienware Aurora 16X optimization (2560x1600) */
  @media (min-width: 2560px) {
    max-width: 1800px;
    width: auto;
    height: auto;
    min-width: 1400px;
    min-height: 800px;
  }

  @media (min-width: 1920px) and (max-width: 2559px) {
    max-width: 1400px;
    min-width: 1000px;
    min-height: 600px;
  }
`;

const Notice = styled.p`
  font-size: 1.2rem;
  margin-bottom: 20px;
  text-align: center;
  font-family: 'Creepster', Arial, sans-serif;

  /* Alienware Aurora 16X optimization (2560x1600) */
  @media (min-width: 2560px) {
    font-size: 3rem;
    margin-bottom: 40px;
    padding: 0 100px;
    line-height: 1.5;
  }

  @media (min-width: 1920px) and (max-width: 2559px) {
    font-size: 2.2rem;
    margin-bottom: 30px;
    padding: 0 60px;
  }

  /* iPhone 15+ and Samsung Galaxy optimization */
  @media (max-width: 430px) {
    font-size: 1.1rem;
    margin-bottom: 20px;
    padding: 0 10px;
    line-height: 1.4;
  }

  @media (max-width: 390px) {
    font-size: 1rem;
    margin-bottom: 15px;
    padding: 0 8px;
  }

  @media (max-width: 360px) {
    font-size: 0.9rem;
    margin-bottom: 12px;
    padding: 0 5px;
  }
`;

const Input = styled.input`
  padding: 10px;
  font-size: 1rem;
  margin-bottom: 10px;
  font-family: 'Creepster', Arial, sans-serif;

  /* Alienware Aurora 16X optimization (2560x1600) */
  @media (min-width: 2560px) {
    padding: 20px 30px;
    font-size: 2rem;
    margin-bottom: 30px;
    min-width: 400px;
    border-radius: 10px;
  }

  @media (min-width: 1920px) and (max-width: 2559px) {
    padding: 15px 25px;
    font-size: 1.5rem;
    margin-bottom: 20px;
    min-width: 350px;
    border-radius: 8px;
  }

  /* iPhone 15+ and Samsung Galaxy optimization */
  @media (max-width: 430px) {
    padding: 12px 20px;
    font-size: 1rem;
    margin-bottom: 15px;
    min-width: auto;
    width: 100%;
    max-width: 95%;
    border-radius: 6px;
  }

  @media (max-width: 390px) {
    padding: 10px 18px;
    font-size: 0.9rem;
    margin-bottom: 12px;
    max-width: 98%;
  }

  @media (max-width: 360px) {
    padding: 8px 15px;
    font-size: 0.85rem;
    margin-bottom: 10px;
    max-width: 100%;
  }
`;

const Button = styled.button`
  padding: 10px 20px;
  font-size: 1rem;
  background-color: #4c0065;
  color: white;
  border: none;
  cursor: pointer;
  font-family: 'Creepster', Arial, sans-serif;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    background-color: purple;
    transform: scale(1.05);
  }

  /* Alienware Aurora 16X optimization (2560x1600) */
  @media (min-width: 2560px) {
    padding: 25px 50px;
    font-size: 2.5rem;
    border-radius: 15px;
    min-width: 300px;
  }

  @media (min-width: 1920px) and (max-width: 2559px) {
    padding: 20px 40px;
    font-size: 2rem;
    border-radius: 12px;
    min-width: 250px;
  }

  /* iPhone 15+ and Samsung Galaxy optimization */
  @media (max-width: 430px) {
    padding: 12px 25px;
    font-size: 1.1rem;
    border-radius: 8px;
    min-width: auto;
    width: 100%;
    max-width: 95%;
  }

  @media (max-width: 390px) {
    padding: 10px 20px;
    font-size: 1rem;
    max-width: 98%;
  }

  @media (max-width: 360px) {
    padding: 8px 18px;
    font-size: 0.9rem;
    max-width: 100%;
  }
`;

const Error = styled.p`
  color: red;
  margin-top: 10px;
  font-family: 'Creepster', Arial, sans-serif;
  text-align: center;

  /* Alienware Aurora 16X optimization (2560x1600) */
  @media (min-width: 2560px) {
    font-size: 2rem;
    margin-top: 30px;
  }

  @media (min-width: 1920px) and (max-width: 2559px) {
    font-size: 1.5rem;
    margin-top: 20px;
  }
`;
